import { gql } from "@apollo/client";
import { fragments as notesWrapperOrderFragment } from "../../components/NotesWrapper/graph";

const addNoteToOrderProductionJobCustomizationAreaMutation = gql`
  mutation($orderProductionJobCustomizationAreaId: ID!, $note: String!) {
    addNoteToOrderProductionJobCustomizationArea(
      orderProductionJobCustomizationAreaId: $orderProductionJobCustomizationAreaId
      note: $note
    ) {
      errors {
        orderProductionJobCustomizationAreaId
        note
      }
      updatedOrderProductionJobCustomizationArea {
        ...NotesWrapper_orderProductionJobCustomizationArea
      }
      succeeded
    }
  }
  ${notesWrapperOrderFragment.orderProductionJobCustomizationArea}
`;

export default addNoteToOrderProductionJobCustomizationAreaMutation;
